<section class="page-head">
  <div>
    <p class="eyebrow">Repositories</p>
    <h1>Repository pressure</h1>
  </div>
</section>

<section class="filter-bar">
  <label class="filter-field">
    <span>Search repositories</span>
    <input
      class="filter-input"
      type="search"
      [ngModel]="search()"
      (ngModelChange)="search.set($event)"
      (keyup.enter)="load()"
      placeholder="Repository, project, or org" />
  </label>

  <label class="filter-field">
    <span>Status</span>
    <select class="filter-select" [ngModel]="activeFilter()" (ngModelChange)="activeFilter.set($event)">
      <option value="all">All repositories</option>
      <option value="active">Active only</option>
      <option value="inactive">Inactive only</option>
    </select>
  </label>

  <button type="button" class="action-button" (click)="load()">Apply</button>
</section>

@if (notice()) {
  <section class="state-card notice">{{ notice() }}</section>
}

@if (result(); as repositories) {
  @if (repositories.items.length) {
  <section class="table-card">
    <div class="table-meta">
      <span>{{ repositories.paging.totalCount }} repositories</span>
      <span>{{ search() ? 'Filtered results' : 'Sorted by issues found' }}</span>
    </div>

    <div class="table-shell">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Project</th>
            <th>Status</th>
            <th>PRs</th>
            <th>Issues</th>
            <th>Block Rate</th>
            <th>Latest Review</th>
          </tr>
        </thead>
        <tbody>
          @for (repository of repositories.items; track repository.id) {
            <tr>
              <td class="name-cell">
                <a [routerLink]="['/repositories', repository.id]">{{ repository.name }}</a>
                <span class="subtle">{{ repository.organization.name }}</span>
              </td>
              <td>{{ repository.project.name }}</td>
              <td>
                <app-status-chip
                  kind="verdict"
                  [value]="repository.isActive ? 'Approved' : 'Blocked'">
                </app-status-chip>
              </td>
              <td>{{ repository.pullRequestsReviewed }}</td>
              <td>{{ repository.issuesFound }}</td>
              <td>{{ repository.blockRate | number:'1.1-1' }}%</td>
              <td>{{ repository.latestReviewAt | localDate:'short' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </section>
  } @else {
    <section class="state-card">
      <p>No repository activity was found for the selected range.</p>
    </section>
  }
} @else if (loading()) {
  <section class="state-card">Loading repositories…</section>
} @else if (error()) {
  <section class="state-card error">
    <p>{{ error() }}</p>
    <button type="button" class="action-button secondary" (click)="load()">Try again</button>
  </section>
} @else {
  <section class="state-card">
    <p>No repositories matched the current filters.</p>
  </section>
}
